<template>
    <div class="wrap">
        <div>
            <div>
                <el-button @click="addConfig" type="primary" icon="el-icon-circle-plus-outline">添加配置</el-button>
            </div>
            <div class="mt20">
                <el-input placeholder="标题/应用id/应用key/区域编码" class="w300 seekIpt" v-model="keyWord" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                </el-input>
                <el-select class="w120 ml20" v-model="ableVal" clearable placeholder="启用/禁用" @change="ableChange">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="mt10">
            <el-table :data="tableData" class="table-div r30 allDown movePoin" v-loading="tableLoading">
                <el-table-column show-overflow-tooltip width="60" label="序号">
                    <template slot-scope="scope">
                        {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="title" label="标题" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.title?scope.row.title:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="appId" label="应用id" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.appId?scope.row.appId:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="appKey" label="应用key" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.appKey?scope.row.appKey:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="areaCode" label="区域编码" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.areaCode?scope.row.areaCode:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="appUrl" label="URL" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.appUrl?scope.row.appUrl:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="available" label="是否启用" min-width="150">
                    <template slot-scope="scope">
                        <!-- <el-switch v-model="scope.row.available" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否" style="margin-left:-26px"></el-switch> -->
                        <span>{{scope.row.available?scope.row.available:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="remark" label="备注" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.remark?scope.row.remark:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" min-width="240">
                    <template slot-scope="scope">
                        <el-button @click="detail(scope.row)" type="info" plain>详情</el-button>
                        <el-button @click="edit(scope.row)" type="warning" plain>编辑</el-button>
                        <el-button @click="del(scope.row)" type="danger" plain>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:20px;"></ybPagination>
            <config-dialog v-if="configDialogVisible" :configData="configData" :config-dialog-visible="configDialogVisible" @closeConfigDialog="closeConfigDialogVisible"></config-dialog>
        </div>
        
    </div>
</template>
<script>
import * as mapping from '@/utils/enumList'
import ybPagination from '@/components/ybPagination'
import ConfigDialog from './ConfigDialog'
import * as configApi from '@/api/sysConfig'
export default {
    components: {
        ybPagination,
        ConfigDialog
    },
    data() {
        return {
            keyWord: '',
            ableVal: '',
            options: [{
                label: '启用',  
                value: '1'
            }, {
                label: '禁用',
                value: '0'
            }],
            tableData:[],
            tableLoading: false,
            page: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            configData: {
                type: '',
                appId: ''
            },
            configDialogVisible: false
        }
    },
    computed: {
        queryParams: function() {
            return {
                current: this.page.pageNum,
                size: this.page.pageSize,
                keyword: this.keyWord,
                available: this.ableVal
            }
        }
    },
    methods: {
        // 启用禁用筛选
        ableChange(val) {
            this.page.pageNum = 1;
            this.getConfigList();
        },
        // 搜索筛选
        search() {
            this.page.pageNum = 1;
            this.getConfigList();
        },
        getConfigList() {
            this.tableLoading = true;
            configApi.getConfigList(this.queryParams).then(r => {
                if(r.code === 200) {
                    let data = r.data.records;
                    data.forEach(el => {
                        el.available = mapping.keyToVal('available', el.available)
                    })
                    this.tableData = data;
                    this.page.total = r.data.total;
                    this.tableLoading = false;
                }
            }).catch(e=>{})
        },
        // 添加配置
        addConfig() {
            this.configData.type = 'isAdd';
            this.configDialogVisible = true;
        },
        // 详情
        detail(row) {
            this.configData.type = 'isDetail';
            this.configData.appId = row.appId;
            this.configDialogVisible = true;
        },
        // 编辑
        edit(row) {
            this.configData.type = 'isEdit';
            this.configData.appId = row.appId;
            this.configDialogVisible = true;
        },
        // 删除
        del(row) {
            this.$confirm('是否确认删除配置? 此操作不可恢复!', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                configApi.delConfig({appId: row.appId}).then(r => {
                    if (r.code === 200) {
                        this.$message.success('删除成功!')
                    }
                    this.getConfigList();
                })
            }).catch(e => {})
        },
        // 关闭dialog
        closeConfigDialogVisible() {
            this.configDialogVisible = false;
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.getConfigList();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.getConfigList();
            }
        }
    },
    mounted() {
        this.getConfigList();
    }
}
</script>
<style lang="scss" scoped>
    .wrap {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
    }
</style>